import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

interface ZipCodeErrorModalProps {
  open: boolean;
  onClose: () => void;
  message: string;
}

const ZipCodeErrorModal: React.FC<ZipCodeErrorModalProps> = ({ open, onClose, message }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="zip-code-error-modal-title"
      aria-describedby="zip-code-error-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 400 },
          maxWidth: 400,
          bgcolor: 'background.paper',
          borderRadius: '12px',
          boxShadow: 24,
          p: { xs: 3, sm: 4 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography
          id="zip-code-error-modal-title"
          variant="h6"
          component="h2"
          sx={{
            color: '#2372B9',
            fontWeight: 600,
            marginBottom: 2,
            fontSize: { xs: '18px', sm: '20px' },
          }}
        >
          {message}
        </Typography>

        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            minWidth: { xs: 100, sm: "100%" },
            padding: { xs: '8px 24px', sm: '10px 32px' },
            fontSize: { xs: '14px', sm: '16px' },
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: '8px',
          }}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};

export default ZipCodeErrorModal;